@if (currentMap === 'seatmap' && !is3dView) {
<div class="mx-4 font-medium text-lugano-white">
  @if (side === 'L' && neighborsLabels.l) {
  <button (click)="loadNeighbor('left')">
    <i id="left" class="me-2"></i>
    <span>{{ neighborsLabels.l }}</span>
  </button>
  } @else if (side === 'R' && neighborsLabels.r) {
  <button (click)="loadNeighbor('right')">
    <span>{{ neighborsLabels.r }}</span>
    <i id="right" class="ms-2"></i>
  </button>
  }
</div>
}